// extracted by mini-css-extract-plugin
export var reviewFormContainer = "styles-module__reviewFormContainer___SAxzK";
export var trailDataAndClear = "styles-module__trailDataAndClear___O_1Fa";
export var starRatingIconClass = "styles-module__starRatingIconClass___qpyZL";
export var clearContainer = "styles-module__clearContainer___KHcuo";
export var clearIcon = "styles-module__clearIcon___tDGXq";
export var trailName = "styles-module__trailName___L50nF";
export var dateAndActivityName = "styles-module__dateAndActivityName___OKfnb";
export var starRatingContainer = "styles-module__starRatingContainer___QSnV8";
export var ratingAndTextArea = "styles-module__ratingAndTextArea___vfGDx";
export var form = "styles-module__form___a2Dhz";
export var commentTextArea = "styles-module__commentTextArea___AvlFV";
export var sectionLabel = "styles-module__sectionLabel___RA8hC";
export var trailConditionLabel = "styles-module__trailConditionLabel___Tdelu";
export var formButtonContainer = "styles-module__formButtonContainer___TGuva";
export var formButton = "styles-module__formButton___gFXCl";
export var serverError = "styles-module__serverError___GbWQE";
export var activityAndDate = "styles-module__activityAndDate___SXzZD";
export var trailConditions = "styles-module__trailConditions___nVWgX";
export var cloudCheckboxesContainer = "styles-module__cloudCheckboxesContainer___NxEjF";
export var cancelButton = "styles-module__cancelButton___Ia2S4";
export var dropdowns = "styles-module__dropdowns___ns9JE";
export var spacer = "styles-module__spacer____193_";